import React from "react";
import { Iprops } from "./shppingcartheadinginterface";
import { useTranslation } from "react-i18next";
import { RESOURCE } from "../../../const/resource";
import { ICartContextType } from "../ShoppingCartPromo/shoppingcartpromointerface";
import { useCartContext } from "../shoppingcart";

const ShppingCartHeading = (props: Iprops) => {
    const { t } = useTranslation();
    const { isGuestUser }: ICartContextType = useCartContext();

    const getHeaderTitle = () => {
        if (props.showPuchoutHistory) {
            return (t(RESOURCE.MyK_Label_SC_Puchout_History));
        }
        else if (props.showKomatsuCreditHistory) {
            return (t(RESOURCE.MyK_Label_SC_Komatsu_Credit_History));
        }
        else {
            return (t(RESOURCE.MyK_Label_ShoppingCart));
        }
    }

    return (
        <div className="shoppingcart_header-Wrapper">
            <span className="shopping_cart_Heading">{getHeaderTitle()}</span>
            <ul className="shoppingcart_heading-Right">
                {(!isGuestUser && props.komatsuCreditHistoryButtonVisibility) && <li onClick={() => props.komatsuCreditHistoryOnClick()} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_SC_Komatsu_Credit_History)}>{t(RESOURCE.MyK_Label_SC_Komatsu_Credit_History)}</li>}
                <li onClick={() => props.uploadOnClick()} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_ShoppingCart_Upload_Parts_List)}>{t(RESOURCE.MyK_Label_ShoppingCart_Upload_Parts_List)} </li>
                {!isGuestUser && <><li onClick={() => props.savedpartsOnClick()} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_ShoppingCart_Saved_Parts_List)}>{t(RESOURCE.MyK_Label_ShoppingCart_Saved_Parts_List)}</li>
                <li onClick={() => props.quotesOnClick()} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_ShoppingCart_Quote)}>{t(RESOURCE.MyK_Label_ShoppingCart_Quote)}</li>
                <li onClick={() => props.historyOnClick()} onKeyDown={() => { }}  title={t(RESOURCE.MyK_Label_ShoppingCart_Order_History)}>{t(RESOURCE.MyK_Label_ShoppingCart_Order_History)}</li></>}
                {(!isGuestUser && props.punchoutButtonVisibility) && <li onClick={() => props.puchoutHistoryOnClick()} onKeyDown={() => { }} title={t(RESOURCE.MyK_Label_SC_Puchout_History)}>{t(RESOURCE.MyK_Label_SC_Puchout_History)}</li>}
            </ul>
        </div>
    );
};

export default ShppingCartHeading;
